// @flow
import api from 'tim-api';
import { planningGoalsValidation as planningGoalsValidationEndPoint } from 'endPoints';

export const state = {
  planningGoalsValidation: []
};

export const getters = {
  planningGoalsValidation: (state: Object) => state.planningGoalsValidation
};

export const mutations = {
  SET_PLANNING_GOALS_VALIDATION(state: Object, planningGoalsValidation: Array<Object>) {
    state.planningGoalsValidation = planningGoalsValidation;
  }
};

export const actions = {
  // eslint-disable-next-line
  fetchPlanningGoalsValidation({ commit }: Action) {
    return api.get(planningGoalsValidationEndPoint).then(({ data }) => {
      commit('SET_PLANNING_GOALS_VALIDATION', data);
    });
  },

  // eslint-disable-next-line
  downloadPlanningGoalsValidation({ commit }: Action) {
    return api.get(`${planningGoalsValidationEndPoint}/download`, { responseType: 'blob' })
      .then(({ data }) => data);
  },

  // eslint-disable-next-line
  sendValidation({ commit }: Action, payload : Object) {
    return api.post(`${planningGoalsValidationEndPoint}/sendValidation`);
  },

  update({ commit }: Action, payload : Object) {
    return api.put(`${planningGoalsValidationEndPoint}/approves`, payload);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
